import { connect } from 'react-redux';
import Details from './Details';

import { metricUserActivityDetailed } from '../../../../store/actions/metric';

const mapStateToProps = ({ metricReducer }) => ({ metricReducer });
const mapDispatchToProps = { metricUserActivityDetailed };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Details);
